module.exports = __webpack_public_path__ + "static/img/editor.282b2904.png";